export const setCursorPosition = (input: HTMLInputElement, position: number) => {
  input.setSelectionRange(position, position, 'forward');
};
